import React, { useEffect, useState } from "react";
import {
  Button,
  Offcanvas,
  Form,
  Modal,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import useForm from "../../hooks/useForm";
import {
  AddOutlined,
  Texture,
  ShortText,
  WallpaperOutlined,
} from "@mui/icons-material";
import { Checkbox, FormControlLabel } from "@mui/material";
import toast from "react-hot-toast";
import TinyMCE from "./tinyMCE";
import GaleriaPgiModal from "../../pages/pgi/GaleriaPgiModal";
import useHome from "../../hooks/useHome";
import useProduct from "../../hooks/useProduct";
import useAudit from "../../hooks/useAudit";
import { onlyPositiveInputs } from "../../helpers/functions";
import { titleRegex } from "../../helpers/constants";

const SidebarSlidesNews = ({ replicaPgi }) => {
  const { addCategory, getCategories, categories } = useHome();
  const { createAuditRequest } = useAudit();
  const { products, getAllProducts } = useProduct();

  const user = JSON.parse(localStorage.getItem("Usuario"))?.UserLogin?.name;
  const {
    values,
    setValues,
    categoria,
    handleInputChange,
    handleCategorySelectChange,
    handleTagSelectchange,
  } = useForm({
    body: "",
    state: true,
    visible: true,
    imageCover: [],
    imageCover_tablet: [],
    imageCover_mobile: [],
    imageBody: [],
    creator: user,
  });
  const [showNewsSlide, setShowNewsSlide] = useState(false);
  const handleCloseSlide = () => setShowNewsSlide(false);
  const handleShowSlide = () => setShowNewsSlide(!showNewsSlide);
  const [multimedia, setMultimedia] = useState(false);
  const [textImage, setTextImage] = useState(false);
  const [slideNews, setSlideNews] = useState(false);
  const [newsCategory, setNewsCategory] = useState(true);
  const [modalFor, setModalFor] = useState(null);
  const [lastNewsVideos, setLastNewsVideos] = useState(true);

  const handleArtMultimedia = () => setMultimedia(true);
  const handleArtTexto = () => setMultimedia(false);
  const handleTextImage = () => {
    setTextImage(!textImage);
  };
  const handleSlideNews = () => {
    setSlideNews(!slideNews);
  };
  const handleNewsCategory = () => setNewsCategory(!newsCategory);
  const handleLastNewsVideos = () => setLastNewsVideos(!lastNewsVideos);

  const handleSelectChange = (event) => {
    setValues({
      ...values,
      product: event.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let imageCoverValidation = false;
    let bodyValidation = false;

    const title = values.title.trim();

    if (!title || !titleRegex.test(title)) {
      toast.error("Este título contiene caracteres no válidos");
      return;
    }

    if (!multimedia && values.imageCover.length <= 0) {
      toast.error("Imagen Principal Requerida");
    } else {
      imageCoverValidation = true;
    }
    if (!multimedia && values?.body.length <= 0) {
      toast.error("Cuerpo de noticia Requerido");
    } else {
      bodyValidation = true;
    }

    if (imageCoverValidation && bodyValidation) {
      addCategory(categoria);
      await createAuditRequest({
        ...values,
        multimedia,
        moduloTextImage: textImage,
        deleted: false,
        newsCategory: newsCategory,
        lastNewsVideos: lastNewsVideos,
        slideNews: slideNews,
        element: 1,
        creator: "owner",
        publish: true,
      });
    }
  };

  useEffect(() => {
    getCategories();
    getAllProducts({ onlyTitleAndIcon: false, visible: true });
  }, []);

  const productsOptions = products
    ?.filter((item) => item.deleted !== true)
    .map((item) => {
      return { label: item.title, value: item.title };
    });

  // MODAL GALERIA
  const [showGaleria, setShowGaleria] = useState(false);
  const handleCloseGaleria = () => setShowGaleria(false);
  const handleShowGaleria = () => setShowGaleria(true);

  const handleModalClick = (modalFor) => {
    setModalFor(modalFor);
    handleShowGaleria();
  };

  return (
    <>
      <div className="pgi__sidebar-slides">
        {replicaPgi ? (
          <button
            className=" settings_button-pleno overlay-replica-button"
            onClick={handleShowSlide}
          >
            {" "}
            Nueva noticia
          </button>
        ) : (
          <OverlayTrigger
            key="1"
            placement="top"
            overlay={<Tooltip id="1">Nueva noticia</Tooltip>}
          >
            <Button
              className="btn-form-pgi"
              variant="light"
              onClick={handleShowSlide}
            >
              <AddOutlined />
            </Button>
          </OverlayTrigger>
        )}
        <Offcanvas
          show={showNewsSlide}
          onHide={handleCloseSlide}
          className="basePgi__pgi  pgi__sidebar-container"
          placement="end"
          scroll="true"
          enforceFocus
          backdrop={false}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              {multimedia ? "Noticias Multimedia" : "Noticias"}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <form onSubmit={handleSubmit}>
              <button
                type="submit"
                className="settings_button-pleno news_button float-end"
              >
                GUARDAR
              </button>
              <div className="pgi__sidebar-container-items form-group w-100">
                <div className="form-floating pgi__selectProduct">
                  <h3 className="basePgi__comments">Tipo de noticia</h3>
                  {/* determina ALINEACION DEL BLOQUE DE TXT en pantalla, INCORPORAR el class "align-left" <div className="carousel align-left"></div> */}
                  <Form.Check
                    inline
                    label="Noticia de texto"
                    name="type"
                    type="radio"
                    onClick={handleArtTexto}
                    // onChange={handleInputChangeProduct}
                  />
                  {/* determina ALINEACION DEL BLOQUE DE TXT en pantalla, INCORPORAR el class "align-center" <div className="carousel align-center"></div> */}
                  <Form.Check
                    inline
                    label="Noticia multimedia"
                    name="type"
                    type="radio"
                    onClick={handleArtMultimedia}
                    // onChange={handleInputChangeProduct}
                  />
                </div>
                <div className="z-indexSelect">
                  <label htmlFor="section">Categoría</label>
                  <CreatableSelect
                    isClearable
                    name="title"
                    placeholder="Indicar Categoría"
                    onChange={handleCategorySelectChange}
                    isOptionSelected="Video"
                    options={
                      categories
                        ? categories?.map((category) => ({
                            value: category.title,
                            label: category.title,
                          }))
                        : ""
                    }
                    required
                  />
                </div>
                <Modal
                  id="galleryModal"
                  className="modalContenedor__galeria"
                  show={showGaleria}
                  onHide={handleCloseGaleria}
                >
                  <Modal.Header closeButton></Modal.Header>
                  <Modal.Body>
                    <GaleriaPgiModal
                      editProduct={values}
                      setEditProduct={setValues}
                      modalFor={modalFor}
                      handleCloseGaleria={handleCloseGaleria}
                    />
                  </Modal.Body>
                </Modal>
                {multimedia ? (
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      name="video"
                      id="videoM"
                      value={values.link2}
                      onChange={handleInputChange}
                      placeholder="..."
                      required
                      maxLength={200}
                      minLength={2}
                    />
                    <label htmlFor="link2">Video Principal</label>
                  </div>
                ) : (
                  <div className="form-floating">
                    <Button
                      className="btn-form-pgi pgi__head-modules shadow-sm w-50"
                      onClick={() => handleModalClick("imageCover")}
                    >
                      Imagen desktop
                      <WallpaperOutlined />
                    </Button>
                    <p className="basePgi__comments">
                      <span>
                        Imagen para Escritorio (.jpg, .png). Proporción 16:9.
                        Ancho máximo 2048px
                      </span>
                    </p>
                    <Button
                      className="btn-form-pgi pgi__head-modules shadow-sm w-50"
                      onClick={() => handleModalClick("imageCover_tablet")}
                    >
                      Imagen tablet
                      <WallpaperOutlined />
                    </Button>
                    <p className="basePgi__comments">
                      <span>
                        Imagen para Tablet (.webP, .jpg, .png). Proporción 4:3.
                        Ancho máximo 2048px
                      </span>
                    </p>
                    <Button
                      className="btn-form-pgi pgi__head-modules shadow-sm w-50"
                      onClick={() => handleModalClick("imageCover_mobile")}
                    >
                      Imagen mobile
                      <WallpaperOutlined />
                    </Button>
                    <p className="basePgi__comments">
                      <span>
                        Imagen Mobile (.webP, .jpg, .png). Proporción 9:16.
                        Ancho máximo 1200px
                      </span>
                    </p>
                  </div>
                )}

                <div className="form-floating">
                  <input
                    required
                    type="text"
                    className="form-control"
                    name="title"
                    id="title"
                    value={values.title}
                    onChange={handleInputChange}
                    placeholder="..."
                    maxLength={60}
                    minLength={2}
                  />
                  <label htmlFor="title">
                    {multimedia ? "Título del video" : "Título de la noticia"}
                  </label>
                  <p className="basePgi__comments">
                    <span>Máximo de caracteres: 60.</span>
                  </p>
                  <p className="basePgi__comments">
                    <span>
                      No se admiten los siguentes caracteres: "" ( ) * -{" "} /
                    </span>
                  </p>
                </div>

                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    name="top"
                    id="top"
                    value={values.top}
                    onChange={handleInputChange}
                    placeholder="..."
                    required
                    maxLength={140}
                    minLength={2}
                  />
                  <label htmlFor="content">Copete</label>
                  <p className="basePgi__comments">
                    <span>Máximo de caracteres: 140.</span>
                  </p>
                </div>
                {!multimedia && (
                  <>
                    <p>Cuerpo principal de la noticia</p>
                    <div className="form-floating">
                      <TinyMCE
                        values={values.body}
                        handleInputChange={handleInputChange}
                        name={"body"}
                      />
                      <label htmlFor="body">Texto</label>
                    </div>
                    <div className="pgi__select-align-text">
                      <p>Agregar módulo texto - imagen</p>
                      {/* determina ALINEACION DEL BLOQUE DE TXT en pantalla, INCORPORAR el class "align-center" <div className="carousel align-center"></div> */}
                      <Form.Check
                        inline
                        label={
                          <div>
                            <ShortText />
                            <Texture />
                          </div>
                        }
                        name="text-imaget"
                        type="radio"
                        id="text-image"
                        value="text-image"
                        onClick={handleTextImage}
                      />
                    </div>
                    {textImage && (
                      <>
                        <div className="form-floating">
                          <TinyMCE
                            values={values.footer_news}
                            handleInputChange={handleInputChange}
                            name={"footer_news"}
                          />
                          <label htmlFor="body">Texto</label>
                        </div>
                        <div className="form-floating">
                          <Button
                            className="btn-form-pgi pgi__head-modules shadow-sm w-50"
                            onClick={() => handleModalClick("imageBody")}
                          >
                            Imagen para cuerpo
                            <WallpaperOutlined />
                          </Button>
                          <p className="basePgi__comments">
                            <span>
                              Imagen para Escritorio (.jpg, .png). Proporción
                              4:3. Ancho máximo 2048px
                            </span>
                          </p>
                        </div>
                      </>
                    )}
                  </>
                )}
                <hr />
                <div>
                  <label htmlFor="tags">Tags</label>
                  <CreatableSelect
                    id="tags"
                    isClearable
                    isMulti
                    onChange={handleTagSelectchange}
                    placeholder=""
                  />
                </div>
                <div className="form-floating">
                  <input
                    type="number"
                    className="form-control"
                    name="read_time"
                    id="read_time"
                    value={values.read_time}
                    onChange={handleInputChange}
                    placeholder="..."
                    required
                    min={0}
                    onKeyPress={(event) => onlyPositiveInputs(event)}
                  />
                  <label className="labelReadTime" htmlFor="read_time">
                    Tiempo de lectura (Solo número)
                  </label>
                </div>
                <div className="z-indexSelect mt-2">
                  <label htmlFor="product">Relacionado al producto:</label>
                  <Select
                    id="product"
                    options={[
                      { label: "Seleccione un producto", value: "" },
                      ...productsOptions,
                    ]}
                    className="form-selects"
                    name="product"
                    placeholder={
                      values?.product
                        ? values.product
                        : "Seleccione un producto"
                    }
                    onChange={(event) => handleSelectChange(event)}
                  />
                </div>
                <article className="mb-1">
                  <FormControlLabel
                    control={<Checkbox checked={slideNews} />}
                    name="slideNews"
                    label="Publicado en Home Slide"
                    className="mr-1"
                    onClick={handleInputChange}
                    onChange={handleSlideNews}
                    value={slideNews}
                  />
                  <hr />
                  <h4 className="news_subtitle">Módulos relacionales</h4>
                  <FormControlLabel
                    control={<Checkbox checked={newsCategory} />}
                    name="newsCategory"
                    label="Noticias de la categoría"
                    onClick={handleInputChange}
                    onChange={handleNewsCategory}
                    value={newsCategory}
                  />
                  <FormControlLabel
                    control={<Checkbox checked={lastNewsVideos} />}
                    label="Últimos videos"
                    name="lastNewsVideos"
                    onClick={handleInputChange}
                    onChange={handleLastNewsVideos}
                    value={lastNewsVideos}
                  />
                  {/* <FormControlLabel control={<Checkbox />} label="Últimos videos" /> */}
                </article>
              </div>
            </form>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </>
  );
};

export default SidebarSlidesNews;
